import React from 'react';
import ButtonPrimary from '../../components/ButtonPrimary';

export default function ProducTile({ product, length }){
  const { id, title, product_type, image, handle } = product;
  return (
  <div
    className={`product-tile bd1-s-gray-light tal tdn dib curp bgc-white bdrs8 oh ${
      length < 4 ? 'w330 df w100%@sm' : 'h100%'
    }`}
  >
    <div className="product-tile__container df jcsb h100% fxdrc fxdrr@sm posr">
      <div className="product-tile__image-container mb20 mb0@sm w50%@sm">
        <img
          className="product-tile__image w100%"
          src={image?.src}
          alt={title}
        />
      </div>
      <div className="product-tile__info-container pr24 pl24 pt24 pr16@md pl16@md pt16@md w50%@sm df@sm fxdrc@sm jcsb@sm pr8@smx pl8@smx pt8@smx">
        <div className="product-tile__title-container pt24 pt0@sm">
          <div className="product-tile__product-type fz16 fz14@md c-gray-medium mb4 fw400 lh1.5">
            { product_type }
          </div>
          <div className="product-tile__title fz16 fz14@md fw500 c-black trs-c-0.3s-eio lh1.5 mb4">
            { title }
          </div>
        </div>
        <div className="product-tile__button-container pb16 pb8@smx">
          <ButtonPrimary
            className="w100%"
            compact
            href={`/products/${ handle }`}
          >
            View Product
          </ButtonPrimary>
        </div>
      </div>
      <a
        className="product-tile__link posa t0 l0 w100% h100%"
        href={`/products/${ handle }`}
      >
        <span className="sr-only">
          Go to {title} product page
        </span>
      </a>
    </div>
  </div>
  );
}
